
const details = () => import(/* webpackChunkName: "discover" */ '@/views/discover/details.vue');
const article = () => import(/* webpackChunkName: "discover" */ '@/views/discover/article.vue')
const tesc = () => import(/* webpackChunkName: "discover" */ '@/views/discover/tesc.vue')
const video = () => import(/* webpackChunkName: "discover" */ '@/views/discover/video.vue')
const discoverRoute = [

    {
        path: '/discover/details',
        name: 'discoverdetails',
        component: details
    },
    {
        path: '/discover/article',
        name: 'discoverarticle',
        component: article,
        meta:{
            needLogin: true
        }
    },
    {
        path: '/discover/video',
        name: 'video',
        component: video,
  
    },
    
    

]

export default discoverRoute
